import React from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-foundation';
import fetch from 'isomorphic-fetch';

import actions from '../../actions';
import './style.css';

class LoginView extends React.Component {

    constructor(props) {
        super(props);

        this.doLogin = this.doLogin.bind(this);

        this.state = {
            userLogin: "",
            userPassword: "",
        };

        this.onChangeProperty = this.onChangeProperty.bind(this);
    }

    doLogin(e) {
        e.preventDefault();

        fetch(`${this.props.apiUrl}/api/v1/authentication/auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: this.state.userLogin,
                password: this.state.userPassword,
            })
        })
            .then((res) => {
                if (res.status === 404) {
                    alert('Username or password incorrect');
                }
                if (res.status !== 200) {
                    alert('Error ' + res.status);
                    return;
                }
                return res.json();
            }).then(json => {
                    return json.token
            })
            .then(token => this.props.didLogin((token || "").replace(/"/g, '')))
            .catch(alert);

    }

    onChangeProperty(propertyName, value) {
        const newState = {};
        newState[propertyName] = value;
        this.setState(newState);
    }

    render() {
        return (
            <div className="login-view-container">
                <div className="login-view callout">
                    <h1>SMS 1.0</h1>
                    <label htmlFor="userLogin">Email</label>
                    <input type="text" id="userLogin" value={this.state.userLogin} placeholder="Email"
                           onChange={event => this.onChangeProperty('userLogin', event.target.value)}
                    />
                    <label htmlFor="userPassword">Password</label>
                    <input type="password" id="userPassword" value={this.state.userPassword}
                           onChange={event => this.onChangeProperty('userPassword', event.target.value)}
                    />
                    <Button isExpanded color="primary" onClick={this.doLogin}>Login</Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    apiUrl: state.user.apiUrl,
});

const mapDispatchToProps = (dispatch) => ({
    didLogin: (token) => dispatch(actions.user.didLogin(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView)


// WEBPACK FOOTER //
// ./src/components/LoginView/index.js